import { IPlatformCompanySettingData, PlatformImageKinds } from "@/api/moudules/platformCompany.types";

import LargeScreenLogo from "@/assets/image/screen/title1.png"
import LargeScreenName from "@/assets/image/screen/title2.png"
import LargeScreenName__en from "@/assets/image/screen/title2__en.png"

import DefaultLogo from '@/assets/image/common/head-logo.png'
import DefaultPlatform from '@/assets/image/common/head-name.png'
import DefaultLogoUrl__en from '@/assets/image/common/head-logo__en.png'
import DefaultPlatform__en from '@/assets/image/common/head-name__en.png'
import { buildFullFileUrl } from "@/api/moudules/file";

const defaultUrlMap: Record<PlatformImageKinds, { 'cn': string, 'en': string }> = Object.freeze({
    'largeScreenImg': {
        'cn': LargeScreenName,
        'en': LargeScreenName__en,
    },
    'largeScreenLogo': {
        'cn': DefaultLogo,
        'en': DefaultLogoUrl__en,
    },
    'platform': {
        'cn': DefaultPlatform,
        'en': DefaultPlatform__en,
    },
    'logo': {
        'cn': DefaultLogo,
        'en': DefaultLogoUrl__en,
    },
    'weeklyCover': {
        'cn': '',
        'en': '',
    },
    'pageHeader': {
        'cn': '',
        'en': '',
    },
    'pageFooter': {
        'cn': '',
        'en': '',
    },
    'systemLogo': {
        'cn': '/jyx.jpg',
        'en': '/jyx.jpg',
    },
    'companyLogo': {
        'cn': DefaultLogo,
        'en': DefaultLogoUrl__en,
    }
})

export function platformDataValue<T>(vm: Vue, key: keyof IPlatformCompanySettingData): T {
    let platformSetting: IPlatformCompanySettingData = vm.$store.state['platformSetting']
    if(!platformSetting) {
        return null
    }
    return platformSetting[key] as any
}

export function platformImageUrl(vm: Vue, kind: PlatformImageKinds, useDefault = true) {
    let platformSetting: IPlatformCompanySettingData = vm.$store.state['platformSetting']
    let urlKey = kind + 'Url'
    if (platformSetting && platformSetting[urlKey]) {
        return buildFullFileUrl(platformSetting[urlKey])
    }
    if (useDefault) {
        const lang = vm.$i18n.locale
        return defaultUrlMap[kind][lang]
    }
}
